import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './Forgotpassword.css';
import {api, ENDPOINTS } from '../../services/apiConfig'

function Forgotpassword() {

  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await api.vendor.post(ENDPOINTS.vendor.forgotpassword, {
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || 'Password reset link sent to your email');
        
        // Store the JWT token in session storage
        if (data.jwtToken) {
          sessionStorage.setItem('jwtToken', data.jwtToken);
        }
        
        // Store email for the OTP verification page
        sessionStorage.setItem('resetEmail', email);
        
        // Navigate to OTP verification page
        navigate('/forgot-password-otp-verification');
      } else {
        toast.error(data.message || 'Failed to send reset link');
      }
    } catch (error) {
      toast.error('Unable to connect to server');
      console.error('Password reset error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='forgot-password-body'>
      <div className="forgot-password-container">
        <div className="forgot-password-header">
          <img src="/assets/genie.png" alt="Genie Logo" className="forgot-password-logo" />
          <h1>Forgot Password?</h1>
          <p className="forgot-password-subtitle">Enter your email to receive a password reset link</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="forgot-password-form-group">
            <label htmlFor="email">Email Address</label>
            <div className="forgot-password-input-wrapper">
              <i className="forgot-password-icon email-icon"></i>
              <input
                type="email"
                id="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="forgot-password-submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span className="button-loader-container">
                <span className="button-spinner"></span>
                Sending...
              </span>
            ) : (
              'Send Reset Token'
            )}
          </button>
          
          <div className="forgot-password-footer">
            <a href="/login" className="forgot-password-back-link">
              <i className="forgot-password-icon back-icon"></i> Back to Login
            </a>
            <a href="/help" className="forgot-password-help-link">Need Help?</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Forgotpassword;
